module.exports = __webpack_public_path__ + "img/Gallery_2_22.8e72481e.jpeg";